import { of } from 'rxjs';
import { combineEpics } from 'redux-observable';
import { produceLoadLoadingLoadedEpic } from '@ane/core/lib/utils/ReduxObservablesEpicUtils';
import { getCompletedAsyncWrapperObj } from '@ane/core/lib/models/IAsyncWrapper';
import MdsDataplaneResource from '@ane/exp-data/lib/resources/MdsDataplaneResource';
import FlightSearchResources from '@ane/exp-data/lib/resources/FlightSearchResources';
import NavigationService from '@ane/core/lib/services/NavigationService';
import { ROUTES } from '@ane/exp-data/lib/routes/Routes.constants';
import { getExperimentationGroupIdFromPath } from '@ane/exp-data/lib/utils/ManagementGroup';
import MasterDataConstants from '@ane/exp-data/lib/constants/FeatureDataConstants';
import EnvironmentService from '@ane/core/lib/services/EnvironmentService';
import { managementGroupsActionTypes, loadingManagementGroups, loadedManagementGroups, flightControlActionTypes, loadingFlightControl, loadedFlightControl, creatingFlights, flightsCreated, createFlightActionTypes, validateFlightsActionTypes, validatingFlights, createFlights, validatedFlights, } from './CreateContainer.ducks';
import FlightResource from '../../../FlightDetailsView/resources/Flight.resource';
export const loadFlightControlEpic = produceLoadLoadingLoadedEpic({
    filterOnType: flightControlActionTypes.LOAD,
    loadResource: ({ workspaceId, managementGroup }) => {
        const experimentationGroup = getExperimentationGroupIdFromPath(workspaceId, managementGroup);
        return MdsDataplaneResource.getConfigWithTypeV2({
            workspaceId,
            experimentationGroup,
            section: MasterDataConstants.flightControlSection,
        });
    },
    loadingAction: loadingFlightControl,
    loadedAction: (data, payload, error) => of(loadedFlightControl(getCompletedAsyncWrapperObj(data, error))),
});
export const loadManagementGroupsEpic = produceLoadLoadingLoadedEpic({
    filterOnType: managementGroupsActionTypes.LOAD,
    loadResource: ({ workspaceId, managementGroup }) => {
        const experimentationGroup = getExperimentationGroupIdFromPath(workspaceId, managementGroup);
        return MdsDataplaneResource.getChildPaths(workspaceId, experimentationGroup);
    },
    loadingAction: loadingManagementGroups,
    loadedAction: (data, payload, error) => of(loadedManagementGroups(getCompletedAsyncWrapperObj(data, error))),
});
export const validateFlightsEpic = produceLoadLoadingLoadedEpic({
    filterOnType: validateFlightsActionTypes.LOAD,
    loadResource: ({ managementGroup, workspaceId, flightConfiguration }) => {
        const flightIds = flightConfiguration.FlightConfigurations.map((flight) => flight.Name).join(',');
        return FlightSearchResources.searchFlights(`?workspaceId=${workspaceId}&managementGroup=${managementGroup}&q=Flights:${flightIds}`);
    },
    loadingAction: validatingFlights,
    loadedAction: (data, payload, error) => {
        var _a, _b;
        /**
         * Return dictionary of flights that exist
         */
        const results = {};
        (_a = data === null || data === void 0 ? void 0 : data.Results) === null || _a === void 0 ? void 0 : _a.forEach((flight) => {
            results[flight.FlightName] = true;
        });
        const flightsExist = !!(((_b = payload.flightConfiguration) === null || _b === void 0 ? void 0 : _b.FlightConfigurations) || []).filter((flight) => !!results[flight.Name]).length;
        if (!flightsExist) {
            /**
             * If flights are valid create flights
             */
            return of(createFlights(payload), validatedFlights(getCompletedAsyncWrapperObj(results, error)));
        }
        else {
            return of(validatedFlights(getCompletedAsyncWrapperObj(results, error)));
        }
    },
});
export const createFlightsEpic = produceLoadLoadingLoadedEpic({
    filterOnType: createFlightActionTypes.LOAD,
    loadResource: ({ tenant, workspaceId, flightConfiguration }) => FlightResource.createFlights(tenant, workspaceId, flightConfiguration),
    loadingAction: creatingFlights,
    loadedAction: (data, payload, error) => {
        const { managementGroup } = payload;
        if (!error) {
            const user = EnvironmentService.getUser().alias;
            const flights = payload.flightConfiguration.FlightConfigurations.map((flight) => flight.Name).join(',');
            let pathname = `${ROUTES.searchFlights.location.pathname}?managementgroup=${managementGroup}&q=Flight:${flights}`;
            pathname += !!user ? `,Owner:${user}` : '';
            NavigationService.navigateTo(pathname);
            return of(flightsCreated(getCompletedAsyncWrapperObj(data, error)));
        }
        else {
            return of(flightsCreated(getCompletedAsyncWrapperObj(data, error)));
        }
    },
});
export default combineEpics(loadManagementGroupsEpic, loadFlightControlEpic, createFlightsEpic, validateFlightsEpic);

//# sourceMappingURL=CreateContainer.epics.js.map
